import { Batch } from "../../Models/Batch";
import ActionType from "../../Models/ActionType";
import * as types from "./types";
import { Product } from "../../Models/Product";
import { Producer } from "../../Models/Producer";
import { Pallet } from "../../Models/Pallet";
import { Contract } from "../../Models/Contract";

export interface ContractsState {
  contracts: Contract[];
  fetchingContracts: boolean;
}

const initialState: ContractsState = {
  contracts: [],
  fetchingContracts: false,
};

const contracts = (
  state: ContractsState = initialState,
  action: ActionType
): ContractsState => {
  switch (action.type) {
    case types.FETCH_CONTRACTS:
      return {
        ...state,
        fetchingContracts: true,
      };
    case types.FETCH_CONTRACTS_FAILURE:
      return {
        ...state,
        fetchingContracts: false,
      };
    case types.FETCH_CONTRACTS_SUCCESS:
      return {
        ...state,
        contracts: action.payload,
      };
    default:
      return state;
  }
};

export default contracts;
